// removed by extract-text-webpack-plugin
module.exports = {"page":"_9LYWMNhzTOjsJK_vrZY3O","popupBox":"_28vrOI1XNevB2uI3BHBe7b","preloaderWrap":"HjuoGvJreci5JeiCSqiJ"};


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/pages/EpicMigration.scss
// module id = 2950
// module chunks = 0